import script from "./Social.vue?vue&type=script&setup=true&lang=js"
export * from "./Social.vue?vue&type=script&setup=true&lang=js"

import "./Social.vue?vue&type=style&index=0&id=251d1cd4&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-251d1cd4"]])

export default __exports__